import * as yup from 'yup';
import { messages as M } from '../utils/constants/message';
import { getEnding } from 'utils/getEnding';

export const signInSchema = (isENLang: boolean) =>
  yup.object().shape({
    email: yup
      .string()
      .email(M.INVALID_MAIL[getEnding(isENLang)])
      .required(M.REQUIRED[getEnding(isENLang)]),
    password: yup.string().required(M.REQUIRED[getEnding(isENLang)]),
  });
